import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const ordersAPI = createApi({
    reducerPath: "ordersAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllOrders: builder.mutation({
            query: ({ page, size, key, status, startDate, endDate, city, paymentStatus }) => {
                let apiUrl = `admin/order?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                if (status) {
                    apiUrl += `&status=${status}`;
                }

                if (startDate && endDate) {
                    apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
                }

                if (city) {
                    apiUrl += `&city=${city}`;
                }

                if(paymentStatus){
                    apiUrl += `&paymentStatus=${paymentStatus}`
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["orders"],
        }),
        getSpecificOrderDetails: builder.mutation({
            query: ({ id }) => {
                let apiUrl = `admin/order/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        updateOrderStatus: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/order/status`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["orders"],
        }),
        markOrderAsPaid: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/order/mark-as-paid`,
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["orders"],
        }),

        getReturnedOrderDetails: builder.mutation({
            query: ({ page, size, status }) => {
                let apiUrl = `admin/order-return?page=${page}&limit=${size}`;

                if(status){
                    apiUrl += `&ststus=${status}`
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ['returned_orders']
        }),
        getReturnedOrderRefundDetails: builder.query({
            query: ({ page, size }) => {
                let apiUrl = `admin/order-refund?page=${page}&limit=${size}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ['returned_orders_refunds']
        }),
        getSpecificReturnedOrderDetails: builder.query({
            query: ({id}) => {
                let apiUrl = `admin/order-return/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ['returned_order_details']
        }),
        acceptOrderReturn: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/order-return/proceed`,
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["returned_orders"],
        }),
        declineOrderReturn: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/order-return/decline`,
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["returned_orders"],
        }),

        getOrderInsights: builder.mutation({
            query: ({ startDate, endDate }) => {
                let apiUrl = `admin/order/insight?startDate=${startDate}&endDate=${endDate}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["orders_insights"],
        }),
        getSalesInsights: builder.mutation({
            query: ({ startDate, endDate }) => {
                let apiUrl = `admin/sales/insight?startDate=${startDate}&endDate=${endDate}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["orders_insights"],
        }),

        getUtilities: builder.mutation({
            query: () => {
                let apiUrl = `admin/util`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["utilities"],
        }),
        updateUtilities: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/util`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["utilities"],
        }),
    })
});

export const { 
    useGetAllOrdersMutation,
    useGetSpecificOrderDetailsMutation,
    useUpdateOrderStatusMutation,
    useMarkOrderAsPaidMutation,

    useGetReturnedOrderDetailsMutation,
    useGetReturnedOrderRefundDetailsQuery,
    useGetSpecificReturnedOrderDetailsQuery,
    useAcceptOrderReturnMutation,
    useDeclineOrderReturnMutation,

    useGetOrderInsightsMutation,
    useGetSalesInsightsMutation,

    useGetUtilitiesMutation,
    useUpdateUtilitiesMutation
} = ordersAPI;

export default ordersAPI;